import React from 'react';
import {Outlet} from "react-router-dom";
import Header from '../components/Header'
import BackgroundImage from "../components/BackgroundImage";
import Footer from "../components/Footer";

function Layout() {
    return (
        <div style={{minHeight: "100vh", position: "relative"}}>
            <Header />
            <BackgroundImage />
            <Outlet />
            <Footer />
        </div>
    );
}

export default Layout;